<template>
  <div>
    <list-template
      :table-config="tableConfig"
      :table-data="tableData"
      :total="total"
      :loading="loading"
      :current-page="page"
      @onChangePage="handleCurrentChange"
      @onHandle="handleClick"
      @onChange="onChange"
      @onAdd="$router.push('./add')"
    >
    </list-template>
    <Dialog :visible.sync="visible" showLine title="历史记录" :showFooter="false">
      <TimeLine :list="list" reverse v-loading="dialogLoading"></TimeLine>
    </Dialog>
  </div>
</template>

<script>
import Dialog from '@/components/common/Dialog'
import TimeLine from '@/components/common/TimeLine'
import { tableListMixin } from '@/utils/mixins'
import { zs_opt_history } from '@/api'
export default {
	_config:{"route":{"path":"list","meta":{"title":"列表"}}},
  mixins: [tableListMixin],
  components: { Dialog, TimeLine },
  methods: {
    getData() {
      this.getDataApi('/zhaosheng/api/recruit-2024/exam/list-exam-enroll-conf')
    },
    handleClick(row, handle) {
      const { type } = handle
      if (type === 'edit') {
        this.$router.push('./edit?id=' + row.id)
      } else if (type === 'viewHistory') {
        this.getHistory(row.id)
        this.visible = true
      }
    },
    getHistory(id) {
      this.list = []
      this.dialogLoading = true
      zs_opt_history({ type: 'examination_enroll_2024', id }).then(res => {
        const { list } = res
        this.list = list.map(i => ({ content: i.change_detail }))
      }).finally(() => this.dialogLoading = false)
    },
  },
  data() {
    return {
      visible: false,
      dialogLoading: false,
      list: [],
      tableConfig: [
        { prop: 'school_name', label: '学校' },
        { prop: 'city_name', label: '学校所属城市' },
        { prop: 'year', label: '入学年份' },
        { prop: 'score_type', label: '当地计分方式', render: (row) => row.score_type ? '等级' : '分数' },
        // { prop: 'first_line', label: '第一档录取分', render: (row) => row.score_type ? row.first_line_level : row.first_line },
        // { prop: 'second_line', label: '第二档录取分', render: (row) => row.score_type ? row.second_line_level : row.second_line },
        { prop: 'chinese_percent', label: '语文合格得分率', render: ({chinese_percent}) => `${chinese_percent}%` },
        { prop: 'math_percent', label: '数学合格得分率', render: ({math_percent}) => `${math_percent}%` },
        { prop: 'creator', label: '创建人' },
        { prop: 'created_at', label: '创建时间' },
        { label: '操作', width: '200rem', handle: true }
      ]
    }
  },
}
</script>

<style lang="scss" scoped></style>
